import { Segmented, Input, Form } from 'antd';
import { useCallback, useEffect, useRef, useState } from 'react';
import { OrganizationFields } from './OrganizationFields';
import { AddNotificationTimes } from './AddNotificationTimes';
import { Button } from '../../../baseComponents';
import '../Organization/Organization.scss';
import { BackIconMobile, WarningOrgIcon } from 'src/icons';
import { useNavigate } from 'react-router-dom';
import EmailEditor from './EmailEditor';
import UploadImages from './UploadImages';
import OrgJsonEditor from './OrgJsonEditor';
import {
  addOrganizationAction,
  defaultNotificationTemplateAction,
  ehrFilterOrganizationAction,
  getAllActiveOrganizationAction,
  uploadOrganizationLogoAction,
} from 'src/modules/SuperAdmin/store/actions/organization.action';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import * as Yup from 'yup';
import { useSelector } from 'react-redux';
import { getFromStorage } from 'src/lib/storage';
import { v4 as uuidv4 } from 'uuid';
import { showToastError } from 'src/utilities/errortoast';
import { useAuth } from '@frontegg/react';
import { analytics } from 'src/services';

const { TextArea } = Input;

export const AddOrganizationPage = () => {
  const [form] = Form.useForm();
  const { defaultNotificationTemplate, ehrFilterOrganizationList } =
    useSelector((state) => state?.organizationState);
  const cachedUserEmail = getFromStorage(`user_email`);

  const navigate = useNavigate();
  const { user } = useAuth();

  const dispatch = useDispatch();
  const isMobile = window.innerWidth < 1260;
  const [showEditor, setShowEditor] = useState(true);
  const [notificationStartHour, setNotificationStartHour] = useState('8');
  const [notificationStartMinute, setNotificationStartMinute] = useState('00');
  const [notificationEndHour, setNotificationEndHour] = useState('7');
  const [notificationEndMinute, setNotificationEndMinute] = useState('00');
  const [notificationStartRadio, setNotificationStartRadio] = useState(1); // AM
  const [notificationEndRadio, setNotificationsEndRadio] = useState(2); // PM
  const [emailContent, setEmailContent] = useState(
    defaultNotificationTemplate?.email?.body || ''
  );
  const [emailDefaultBodyContent, setEmailDefaultBodyContent] = useState(null);
  const [emailDefaultSubjectContent, setEmailDefaultSubjectContent] =
    useState(null);
  const [subjectContent, setSubjectContent] = useState(
    defaultNotificationTemplate?.email?.subject || ''
  );
  const [smsContent, setSmsContent] = useState(
    defaultNotificationTemplate?.sms?.body || ''
  );
  const [selectedSegment, setSelectedSegment] = useState('logo');
  const [selectedFile, setSelectedFile] = useState(null);
  const [subjectEditorContent, setSubjectEditorContent] =
    useState(subjectContent);
  const [bodyEditorContent, setBodyEditorContent] = useState(emailContent);
  const defaultJsonValue = `{
"Intake_ambient_combo": true,
"enable_ambient_ai": true,
"enable_bulk_appointment_upload": true,
"enable_chat_classification": false,
"enable_chat_followup": true,
"enable_chat_moderation": false,
"enable_intake_summary_feedback": true,
"enable_intake_summary_regeneration": true,
"enable_language_selection": true,
"enable_live_transcription": true,
"enable_patient_email_notifications": true,
"enable_patient_sms_notifications": true,
"enable_practitioner_email_notifications": true,
"enable_template_exchange": true,
"intake_summary_regeneration_passes": 2,
"sender_email": "hello@insighthealth.ai",
"sender_email_name": "Insight Health",
"show_qr_code": true
}`;
  const [jsonInput, setJsonInput] = useState(defaultJsonValue);
  const [isValidJson, setIsValidJson] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');
  const [storedAreaCode, setStoredAreaCode] = useState([]);
  const [preferredAreaCodes, setPreferredAreaCodes] = useState([]);
  const [inputValue, setInputValue] = useState('');

  const [editingMode, setEditingMode] = useState('subject');
  const formikFormRef = useRef();
  const [submitInValidJson, setSubmitInValidJson] = useState(false);
  const [submitWithoutNotification, setSubmitWithoutNotification] =
    useState(false);

  const validationSchema = Yup.object().shape({
    org_name: Yup.string()
      .required('Organization name is required')
      .matches(/^\S.*$/, 'Organization name cannot start with a space'),
    ehr_id: Yup.string().required('EHR system is required'),
    frontegg_plan_ids: Yup.array().required('Frontegg plans are required'),
    website: Yup.string()
      .required('Website URL is required')
      .matches(
        /^(https?:\/\/)?(www\.)?[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(\/\S*)?$/,
        'Website URL is not valid'
      ),
  });

  useEffect(() => {
    dispatch(defaultNotificationTemplateAction());
    dispatch(ehrFilterOrganizationAction());
    dispatch(getAllActiveOrganizationAction());
  }, [dispatch]);

  useEffect(() => {
    setEmailContent(defaultNotificationTemplate?.email?.body);
    setSubjectContent(defaultNotificationTemplate?.email?.subject);
  }, [defaultNotificationTemplate]);

  useEffect(() => {
    const smsBodyHtml = defaultNotificationTemplate?.sms?.body || '';
    // Convert HTML to plain text
    const parser = new DOMParser();
    const htmlDoc = parser.parseFromString(smsBodyHtml, 'text/html');
    let smsBodyText = htmlDoc.body.textContent || '';
    // Replace HTML newline with actual new lines
    smsBodyText = smsBodyText.replace(/\\n/g, '\n');
    // Set the plain text content to smsContent state
    setSmsContent(smsBodyText);
  }, [defaultNotificationTemplate]);

  const handleSegmentChange = (segment) => {
    setSelectedSegment(segment);
    setEditingMode('subject');
    if (segment === 'logo') {
      setShowEditor(true);
    } else {
      setShowEditor(false);
    }
  };

  const formatting_Time = (hour, meredien) => {
    const am_pm_Radio =
      meredien === 'start' ? notificationStartRadio : notificationEndRadio;
    if (am_pm_Radio === 2 && hour !== 12) {
      hour += 12;
    }
    if (am_pm_Radio === 1 && hour === 12) {
      hour = 0;
    }
    return hour;
  };
  useEffect(() => {
    if (notificationStartHour === 12 && notificationStartRadio === null) {
      setNotificationStartRadio(1);
    }

    if (notificationEndHour === 12 && notificationEndRadio === null) {
      setNotificationsEndRadio(1);
    }
  }, [notificationStartHour, notificationEndHour]);

  const [orgData, setOrgData] = useState({
    logoUUID: uuidv4(),
    org_name: '',
    ehr_id: '',
    comm_id: null,
    allowed_domains: '',
    website: '',
    settings: '',
    logo_url: 'https://images.insighthealth.ai/new_insight_logo.jpg',
    logo_file: '',
    logo_type: '',
    phone_data: {
      phone_text: '',
      phone_type: '',
    },
    email_data: {
      email_text: '',
      email_type: '',
    },
    sms: {
      subject: '',
      body: '',
    },
    address: {
      line_1: '',
      line_2: '',
      city: '',
      state: '',
      zip: '',
      country: 'USA',
      address_type: '',
    },
    org_setting_start_time: '',
    org_setting_end_time: '',
    preferred_phone_area_codes: [],
    create_frontegg_account: true,
    created_by: cachedUserEmail,
    frontegg_plan_ids: [],
    mirror_org_id: '',
  });

  const handleSubmit = () => {
    form.validateFields();
    if (formikFormRef.current) {
      formikFormRef.current.handleSubmit();
      if (preferredAreaCodes.length == 0) {
        document
          .querySelector('[name="preferred_phone_area_codes_requiredMsg"]')
          .classList.remove('hidden');
      }
      formikFormRef.current.validateForm().then(() => {
        if (
          Object.keys(formikFormRef.current.errors).length == 0 &&
          preferredAreaCodes.length != 0
        ) {
          formSubmitAction();
        }
      });
    }
    setSubmitWithoutNotification(false);
    if (
      !notificationStartHour ||
      !notificationStartMinute ||
      !notificationEndHour ||
      !notificationEndMinute ||
      !notificationStartRadio ||
      !notificationEndRadio
    ) {
      setSubmitWithoutNotification(true);
      return;
    }
    if (!isValidJson) {
      setSubmitInValidJson(true);
      return;
    }
  };
  const updateSettingsJson = useCallback((jsonData) => {
    setOrgData((prevOrgData) => ({
      ...prevOrgData,
      settings: jsonData,
    }));
  }, []);

  const formSubmitAction = () => {
    const browserTimezone = moment.tz.guess();
    // Notification Start time conversion : Starts
    const startHour = parseInt(notificationStartHour);
    const startMinute = parseInt(notificationStartMinute);
    let formatted_start_hour = startHour;
    const start_time = formatting_Time(formatted_start_hour, 'start');
    const formatted_Start_Time = moment.tz(
      { hour: start_time, minute: startMinute },
      browserTimezone
    );
    const final_Start_Time = formatted_Start_Time.utc().format('HH:mm');
    //Notification Start time conversion : Ends

    // Notification End time : Starts
    const endHour = parseInt(notificationEndHour);
    const endMinute = parseInt(notificationEndMinute);
    let formatted_end_hour = endHour;
    const end_time = formatting_Time(formatted_end_hour, 'end');
    const formatted_End_Time = moment.tz(
      { hour: end_time, minute: endMinute },
      browserTimezone
    );
    const final_End_Time = formatted_End_Time.utc().format('HH:mm');
    // Ends
    const smsUnchanged =
      smsContent ===
      (defaultNotificationTemplate?.sms?.body.replace(/\\n/g, '\n') || '');

    const convertCodeToInt = preferredAreaCodes.map((code) => parseInt(code));

    const settingsJson = jsonInput ? JSON?.parse(jsonInput) : null;
    const updatedOrgData = {
      ...orgData,
      preferred_phone_area_codes: convertCodeToInt,
      org_setting_start_time:
        final_Start_Time && final_Start_Time !== 'Invalid date'
          ? final_Start_Time
          : null,
      org_setting_end_time:
        final_End_Time && final_End_Time !== 'Invalid date'
          ? final_End_Time
          : null,
      sms: smsUnchanged
        ? null
        : {
            ...orgData?.sms,
            body: smsContent,
          },
      logo_url: orgData?.logo_url ? orgData.logo_url : null,
      is_self_signup: false,
      settings: settingsJson,
    };
    analytics.track('Clicked Save In Patient Notifications Window', {
      email: user?.email,
    });
    // TODO: Create organization only when logo_url is set in state.
    if (
      updatedOrgData.org_name &&
      updatedOrgData.ehr_id &&
      updatedOrgData.org_setting_start_time &&
      updatedOrgData.org_setting_end_time &&
      notificationStartRadio &&
      notificationEndRadio
    ) {
      if (selectedFile) {
        dispatch(
          uploadOrganizationLogoAction(
            {
              file_name: `${orgData.logoUUID}.${selectedFile?.ext}`,
              logo: selectedFile,
            },
            navigate,
            updatedOrgData
          )
        );
      } else {
        updatedOrgData.create_admin_user = true;
        dispatch(addOrganizationAction(navigate, updatedOrgData, null));
      }
    } else {
      showToastError('Please complete all required fields');
    }
  };

  const updateLogoUrl = (url) => {
    setOrgData((prevOrgData) => ({
      ...prevOrgData,
      logo_url: url,
      logo_file: null,
      logo_type: null,
    }));
  };

  const handleBlobSelect = useCallback((blob) => {
    setSelectedFile(blob);
    setOrgData((prevOrgData) => ({
      ...prevOrgData,
      logo_url: null,
      logo_file: {
        ...blob,
        size: blob.size,
        type: blob.type,
      },
    }));
  }, []);

  const handleSelectedFile = (value) => {
    if (value === null) {
      setSelectedFile(null);
      setOrgData((prevOrgData) => ({
        ...prevOrgData,
        logo_file: null,
        logo_type: null,
      }));
    } else {
      setSelectedFile(value);
    }
  };

  return (
    <div className={`page-wrapper`}>
      <div className="flex items-center gap-2 mb-4">
        <BackIconMobile onClick={() => navigate('/superadmin')} />
        <div className="font-bold text-2xl">Add Organization</div>
      </div>
      <div className={isMobile ? '' : 'flex gap-4'}>
        <div className="lg:w-1/2">
          {/* AddOrganization & Address fields*/}
          <div className="bg-white px-4 py-2 rounded-2xl mt-2 pt-4">
            <OrganizationFields
              ref={formikFormRef}
              storedAreaCode={storedAreaCode}
              setStoredAreaCode={setStoredAreaCode}
              isEditPage={false}
              orgData={orgData}
              setOrgData={setOrgData}
              validationSchema={validationSchema}
              ehrFilterOrganizationList={ehrFilterOrganizationList}
              setPreferredAreaCodes={setPreferredAreaCodes}
              preferredAreaCodes={preferredAreaCodes}
              inputValue={inputValue}
              setInputValue={setInputValue}
              setJsonInput={setJsonInput}
              setNotificationStartHour={setNotificationStartHour}
              setNotificationStartMinute={setNotificationStartMinute}
              setNotificationEndHour={setNotificationEndHour}
              setNotificationEndMinute={setNotificationEndMinute}
              setNotificationStartRadio={setNotificationStartRadio}
              setNotificationsEndRadio={setNotificationsEndRadio}
            />
          </div>
          {/* Notifications time  */}
          <div className="bg-white rounded-2xl mt-5">
            <AddNotificationTimes
              isEditPage={false}
              handleSubmit={handleSubmit}
              notificationStartHour={notificationStartHour}
              setNotificationStartHour={setNotificationStartHour}
              notificationStartMinute={notificationStartMinute}
              setNotificationStartMinute={setNotificationStartMinute}
              notificationEndHour={notificationEndHour}
              setNotificationEndHour={setNotificationEndHour}
              notificationEndMinute={notificationEndMinute}
              setNotificationEndMinute={setNotificationEndMinute}
              notificationStartRadio={notificationStartRadio}
              setNotificationStartRadio={setNotificationStartRadio}
              notificationEndRadio={notificationEndRadio}
              validationSchema={validationSchema}
              form={form}
              setNotificationsEndRadio={setNotificationsEndRadio}
              submitWithoutNotification={submitWithoutNotification}
            />
          </div>
        </div>

        <div className="lg:w-1/2 organization">
          <div className="h-[40rem] bg-white px-4 py-2 rounded-2xl mt-2">
            <Segmented
              defaultValue="logo"
              onChange={handleSegmentChange}
              options={[
                { label: 'Logo upload', value: 'logo' },
                { label: 'SMS editor', value: 'sms' },
                {
                  label: (
                    <div className="flex items-center justify-center">
                      <span className="mr-2">Settings</span>
                      <span>
                        {!isValidJson && submitInValidJson && (
                          <WarningOrgIcon />
                        )}
                      </span>
                    </div>
                  ),
                  value: 'settings',
                },
              ]}
            />
            {showEditor && selectedSegment === 'logo' ? (
              <div className="container mx-auto py-2">
                {/* <DndProvider backend={HTML5Backend}> */}
                <UploadImages
                  isEditPage={false}
                  updateLogoUrl={updateLogoUrl}
                  selectedFile={selectedFile}
                  setSelectedFile={handleSelectedFile}
                  handleBlobSelect={handleBlobSelect}
                  setOrgData={setOrgData}
                  orgData={orgData}
                  fromAddPage={true}
                />
              </div>
            ) : selectedSegment === 'editor' ? (
              <>
                <EmailEditor
                  isEditPage={false}
                  emailContent={emailContent}
                  setHtmlContent={setEmailContent}
                  subjectContent={subjectContent}
                  setSubjectContent={setSubjectContent}
                  defaultNotificationTemplate={defaultNotificationTemplate}
                  subjectEditorContent={subjectEditorContent}
                  setSubjectEditorContent={setSubjectEditorContent}
                  bodyEditorContent={bodyEditorContent}
                  setBodyEditorContent={setBodyEditorContent}
                  editingMode={editingMode}
                  setEditingMode={setEditingMode}
                  setEmailDefaultBodyContent={setEmailDefaultBodyContent}
                  emailDefaultBodyContent={emailDefaultBodyContent}
                  setEmailDefaultSubjectContent={setEmailDefaultSubjectContent}
                />
              </>
            ) : selectedSegment === 'sms' ? (
              <div className="border-2 border-[#ccc] rounded-lg mt-4">
                <div className="h-[35rem] grid grid-cols-1 gap-4 mt-2 ">
                  <TextArea
                    bordered={false}
                    rows={24}
                    placeholder="Add sms editor."
                    style={{
                      resize: 'none',
                      fontFamily: 'Poppins',
                    }}
                    value={smsContent}
                    onChange={(e) => setSmsContent(e.target.value)}
                  />
                </div>
              </div>
            ) : (
              <div>
                <OrgJsonEditor
                  isEditPage={false}
                  initialJson={orgData.settings}
                  updateSettingsJson={updateSettingsJson}
                  jsonInput={jsonInput}
                  setJsonInput={setJsonInput}
                  isValidJson={isValidJson}
                  setIsValidJson={setIsValidJson}
                  errorMessage={errorMessage}
                  setErrorMessage={setErrorMessage}
                />
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="flex justify-center items-center mt-4">
        <Button type={'button'} onClick={handleSubmit}>
          Submit
        </Button>
      </div>
    </div>
  );
};
